const RaindropDivider = ({ isHidden = false, isVertical = false }) => {
  let opacity = "opacity-100";

  let dimensions = "h-1 w-full";

  if (isHidden) {
    opacity = "opacity-0";
  }

  if (isVertical) {
    dimensions = "w-1 h-full";
  }

  return (
    <div
      className={`${dimensions} ${opacity} bg-color-border-primary dark:bg-color-dark-border-primary rounded-lg`}
    />
  );
};

export default RaindropDivider;
